import { makeAutoObservable, observable, action, computed, runInAction } from 'mobx';
import AsyncStorage from '@react-native-async-storage/async-storage';

import { LoginReqResponse } from './../server/types/authentication.types';

export class AuthStore {
  auth: LoginReqResponse | null = null;
  onboardingDone: boolean = false;
  authenticated: boolean = false;

  constructor() {
    makeAutoObservable(this, {
      auth: observable,
      onboardingDone: observable,
      authenticated: observable,
      setAuth: action,
      login: action,
      logout: action,
      loggedIn: computed,
      isOnboardingDone: computed,
      userRole: computed,
    });
  }

  async setAuth(authData: LoginReqResponse) {
    this.auth = authData;
    // this.authenticated = true;
    await AsyncStorage.setItem('AuthStore', JSON.stringify({
      auth: this.auth,
      authenticated: false,
      onboardingDone: this.onboardingDone,
    }));
  }

  login() {
    this.authenticated = true;
  }

  async logout() {
    this.auth = null;
    this.authenticated = false;
    await AsyncStorage.removeItem('AuthStore');
    await AsyncStorage.removeItem('ConversationStore');
  }

  completeOnboarding() {
    this.onboardingDone = true;
  }

  get loggedIn() {
    return this.authenticated;
  }

  get isOnboardingDone(): boolean {
    return this.onboardingDone;
  }

  get authData() {
    return this.auth;
  }

  get userRole() {
    return this.auth?.user.userRole;
  }

  // ✅ This is important: call this on app start
  async hydrate() {
    const stored = await AsyncStorage.getItem('AuthStore');
    if (stored) {
      const parsed = JSON.parse(stored);
      runInAction(() => {
        this.auth = parsed.auth;
        this.authenticated = true
        this.onboardingDone = parsed.onboardingDone;
      });
    }
  }
}
